export default function UseController(dispatch) {
  const setIsPaused = (isPaused) => {
    dispatch({
      type: 'SET_IS_PAUSED',
      payload: { isPaused: !isPaused },
    });
  };
  const setSongTimeline = (event, songRef) => {
    const barValue = event.target.value;
    songRef.current.currentTime = barValue;
    dispatch({
      type: 'SET_SONG_TIMELINE',
      payload: { barValue },
    });
  };

  const updateStatusBar = (songRef) => {
    const timeline = songRef.current?.currentTime;
    dispatch({
      type: 'SET_SONG_TIMELINE',
      payload: { barValue: timeline },
    });
  };
  const setSongCurrentIndex = (value = 1) => {
    dispatch({
      type: 'SET_SONG_CURRENT_INDEX',
      payload: { value },
    });
  };

  const setMuted = (muted) => {
    dispatch({
      type: 'SET_MUTED',
      payload: !muted,
    });
  };

  return {
    setIsPaused,
    setSongTimeline,
    updateStatusBar,
    setSongCurrentIndex,
    setMuted,
  };
}
